import api from "./api";
export const fetchTransactionMetrics = async({ queryKey }) => {
  const [, { fetch }] = queryKey;
  let url = `/transactions/metrics/stat?fetch=${fetch}`;
  const response = await api.get(url);
  return response.data;
}

export const fetchTransactions = async ({ queryKey }) => {
  const [, { page, limit, search, orderBy, fetch, searchBy, searchByExactMatch }] = queryKey;
  let url = `/transactions?page=${page}&limit=${limit}`;
  
  if (search) {
    url += `&search=${search}`;
  }
  if (orderBy) {
    url += `&orderBy=${orderBy}`;
  }
  if (fetch) {
    url += `&fetch=${fetch}`;
  }
  if (searchBy && Array.isArray(searchBy)) {
    const params = searchBy.map((field) => `searchBy=${field}`).join('&');
    url += `&${params}`;
  }
  if (searchByExactMatch) {
    url += `&searchByExactMatch=${searchByExactMatch}`;
  }

  const response = await api.get(url);
  return response.data;
}

export const fetchCreditTransaction = async ({ queryKey }) => {
  const [, { page, limit, search, orderBy, fetch, searchBy, searchByExactMatch }] = queryKey;
  let url = `/transactions/type/credit?page=${page}&limit=${limit}`;

  if (search) {
    url += `&search=${search}`;
  }
  if (orderBy) {
    url += `&orderBy=${orderBy}`;
  }
  if (fetch) {
    url += `&fetch=${fetch}`;
  }
  if (searchBy && Array.isArray(searchBy)) {
    const params = searchBy.map((field) => `searchBy=${field}`).join('&');
    url += `&${params}`;
  }
  if (searchByExactMatch) {
    url += `&searchByExactMatch=${searchByExactMatch}`;
  }

  const response = await api.get(url);
  return response.data;
}

export const fetchDebitTransaction = async ({ queryKey }) => {
  const [, { page, limit, search, orderBy, fetch, searchBy, searchByExactMatch }] = queryKey;
  let url = `/transactions/type/debit?page=${page}&limit=${limit}`;

  if (search) {
    url += `&search=${search}`;
  }
  if (orderBy) {
    url += `&orderBy=${orderBy}`;
  }
  if (fetch) {
    url += `&fetch=${fetch}`;
  }
  if (searchBy && Array.isArray(searchBy)) {
    const params = searchBy.map((field) => `searchBy=${field}`).join('&');
    url += `&${params}`;
  }
  if (searchByExactMatch) {
    url += `&searchByExactMatch=${searchByExactMatch}`;
  }

  const response = await api.get(url);
  return response.data;
}

export const fetchTransaction = async ({ queryKey }) => {
  const [, { id }] = queryKey;
  const response = await api.get(`/transactions/${id}`);
  return response.data;
}

export const createTransactionCharge = async(data) => {
  const response = await api.post(`/transactions/charge/create`, data);
  return response.data;
}

export const fetchTransactionFees = async () => {
  const response = await api.get(`/transactions/charges`);
  return response.data;
}

export const fetchTransactionFee = async ({ queryKey }) => {
  const [, id] = queryKey;
  if (id) {
    const response = await api.get(`/transactions/charge/${id}`);
    return response.data;
  } else {
    throw new Error('No transaction fee ID provided');
  }
}

export const updateTransactionFee = async(id, data) => {
  if (id) {
    const response = await api.put(`/transactions/charge/${id}`, data);
    return response.data;
  } else {
    throw new Error('No transaction fee ID provided');
  }
}

export const exportTransaction = async (event, data) => {
  const response = await api.post(`/export/transaction?event=${event}`, data);
  return response.data;
}

// export const exportCreditTransaction = async (event, data) => {
//   const response = await api.post(`/export/creditTransaction?event=${event}`, data);
//   return response.data;
// }

// export const exportDebitTransaction = async (event, data) => {
//   const response = await api.post(`/export/debitTransaction?event=${event}`, data);
//   return response.data;
// }

export const transactionReconciliation = async (data) => {
  const response = await api.post(`/reconciliation/transaction`, data);
  return response.data;
}